    <app-download [externalTitle]="title"></app-download>